module.exports = __webpack_public_path__ + "static/img/fpsl.840aafd0.png";